import { useMemo, useState } from "react"

import { Button, Switch } from "@productlane/ui"

import type { Note } from "./preview-dialog"
import { PreviewDialog } from "./preview-dialog"

interface ColumnStepProps {
	hasHeaders: boolean
	onSuccess: () => void
	back: () => void
	textIndex: number
	sortedData: string[][]
	contactEmailIndex: number
	contactNameIndex: number
	createdAtIndex: number
	isProcessed: boolean
	setIsProcessed: (value: boolean) => void
}

export function ToggleProcessedStep({
	hasHeaders,
	back,
	textIndex,
	onSuccess,
	sortedData,
	contactEmailIndex,
	contactNameIndex,
	createdAtIndex,
	isProcessed,
	setIsProcessed,
}: ColumnStepProps) {
	const [previewDialog, setPreviewDialog] = useState<boolean>(false)

	const notes = useMemo<Note[]>(() => {
		const data = () => {
			if (hasHeaders) {
				return sortedData[textIndex]?.slice(1) ?? []
			}
			return sortedData[textIndex] ?? []
		}
		return data()
			.map((text, i) => ({ text, i }))
			.filter((it) => it.text.trim() !== "")
			.map((it) => {
				const index = hasHeaders ? it.i + 1 : it.i
				const result: Note = { text: it.text }
				if (contactEmailIndex !== -1) {
					result.contactEmail = sortedData[contactEmailIndex]?.[index]
				}
				if (contactNameIndex !== -1) {
					result.contactName = sortedData[contactNameIndex]?.[index]
				}
				if (createdAtIndex !== -1) {
					result.createdAt = sortedData[createdAtIndex]?.[index]
				}

				if (isProcessed) {
					result.state = "PROCESSED"
				}
				return result
			})
	}, [
		hasHeaders,
		sortedData,
		textIndex,
		contactEmailIndex,
		contactNameIndex,
		createdAtIndex,
		isProcessed,
	])

	return (
		<div>
			<Switch
				label="Mark as done"
				name="toggle-processed-switch"
				checked={isProcessed}
				onCheckedChange={setIsProcessed}
			/>
			<div className="mt-4 flex justify-between">
				<Button variant="link" onClick={back}>
					Back
				</Button>
				<Button onClick={() => setPreviewDialog(true)}>Next</Button>
			</div>

			<PreviewDialog
				onSuccess={onSuccess}
				isOpen={previewDialog}
				onOpenChange={() => setPreviewDialog(false)}
				notes={notes}
			/>
		</div>
	)
}
